/*
 * Controls of one field of the homepage vehicle bar (seatfit-home-picker.js): the competitor's dark desktop list
 * with a "Search..." box on top (builds the <li> options, filters them as the shopper types with the shared rules
 * of seatfit-picker-search.js, moves the highlighted row with the arrow keys) and the phone <select>. Kept apart
 * so the picker file stays about the picking flow.
 * f = one field record from the picker: { key, list, search, native, ph, options, value, sig, nsig }.
 */
(function () {
  'use strict';
  if (window.SeatFitHomePickerList) return;
  var S = window.SeatFitPickerSearch; // seatfit-picker-search.js: matching + ranking, arrow keys, Enter

  function item(cls, text) {
    var li = document.createElement('li');
    li.className = cls;
    li.textContent = text;
    return li;
  }

  function rows(f) { return f.list.querySelectorAll('[data-v]'); }

  function setActive(f, li) {
    var old = f.list.querySelector('.is-active');
    if (old) old.classList.remove('is-active');
    if (!li) return;
    li.classList.add('is-active');
    S.reveal(f.list, li);
  }

  // Typing highlights nothing (as on the competitor); an empty box shows the chosen row highlighted.
  // Nothing found shows one "No match" row styled like the empty-list row. A Model list passes the chosen make,
  // as in the drawer: "ram 1500" finds RAM's 1500.
  function filter(f) {
    var q = f.search.value.trim();
    var bar = f.key === 'model' && f.list.closest('sf-home-picker');
    var make = bar && bar.querySelector('.sfh-field[data-key="make"] .sfh-field__val');
    f.matched = S.filter(rows(f), q, 'sfh-field__empty', make ? make.textContent.trim() : '').matched;
    setActive(f, q ? null : f.list.querySelector('[aria-selected="true"]'));
  }

  // Rebuilds the rows only when the options changed (a 100-year list keeps its scroll position).
  // loaded = the vehicle list has arrived; before that a field shows a "..." row.
  function fill(f, loaded, emptyLabel) {
    var sig = (loaded ? 'i' : 'w') + f.options.map(function (o) { return o.value; }).join('|');
    if (sig !== f.sig) {
      f.sig = sig;
      f.list.textContent = '';
      if (!loaded && f.key !== 'type') f.list.appendChild(item('sfh-field__empty', '...'));
      else if (!f.options.length) f.list.appendChild(item('sfh-field__empty', emptyLabel));
      f.options.forEach(function (o) {
        var li = item('sfh-field__opt', o.label);
        li.setAttribute('role', 'option');
        li.setAttribute('data-v', o.value);
        f.list.appendChild(li);
      });
    }
    f.list.querySelectorAll('[data-v]').forEach(function (li) {
      li.setAttribute('aria-selected', li.getAttribute('data-v') === f.value ? 'true' : 'false');
    });
    filter(f);
  }

  // The phone <select> of the same field. Options are rebuilt only when the list changed, so an open OS wheel is
  // not reset; Type keeps the products Liquid printed. loaded = the vehicle list of the chosen Type has arrived.
  function syncSelect(f, enabled, loaded, emptyLabel) {
    var sel = f.native;
    if (f.key !== 'type') {
      var sig = f.options.map(function (o) { return o.value; }).join('|');
      if (sig !== f.nsig) {
        f.nsig = sig;
        sel.textContent = '';
        if (f.ph) sel.appendChild(f.ph.cloneNode(true));
        if (!f.options.length && emptyLabel && loaded) {
          var none = new Option(emptyLabel, '__none');
          none.disabled = true;
          sel.appendChild(none);
        }
        f.options.forEach(function (o) { sel.appendChild(new Option(o.label, o.value)); });
      }
      sel.value = f.value || '';
    } else if (f.value) {
      sel.value = f.value;
    }
    sel.disabled = !enabled || (f.key !== 'type' && !loaded);
  }

  // Keys typed in the search box. onChoose(value) picks a row; onClose() shuts the list.
  function onKey(f, e, onChoose, onClose) {
    var vis = S.visible(rows(f));
    var cur = f.list.querySelector('.is-active');
    var next = S.step(vis, cur, e.key);
    if (next !== undefined) {
      e.preventDefault();
      if (next) setActive(f, next);
    } else if (e.key === 'Enter') {
      e.preventDefault();
      var li = S.enterRow(vis, cur, f.matched);
      if (li) onChoose(li.getAttribute('data-v'));
    } else if (e.key === 'Escape') {
      e.preventDefault();
      onClose(true);
    } else if (e.key === 'Tab') {
      onClose(false);
    }
  }

  window.SeatFitHomePickerList = { fill: fill, filter: filter, onKey: onKey, syncSelect: syncSelect };
})();
